"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrepareData = void 0;
var _EXPORTS_1 = require("../../../../../utils/_EXPORTS");
var usePrepareData = function (_a) {
    var data = _a.data, valuePath = _a.valuePath, labelPath = _a.labelPath, tooltipLabelsMapping = _a.tooltipLabelsMapping, groupBy = _a.groupBy;
    // Check if it's breakdown data (array of valuePaths) or simple data
    var isBreakdown = Array.isArray(valuePath);
    if (!isBreakdown) {
        // If groupBy is specified, group the data by that field
        if (groupBy && data.length > 0 && groupBy in data[0]) {
            // Group data by the specified field
            var groupedData_1 = {};
            data.forEach(function (item) {
                var groupKey = (0, _EXPORTS_1.getVal)(item, groupBy) || 'Uncategorized';
                if (!groupedData_1[groupKey]) {
                    groupedData_1[groupKey] = {
                        items: [],
                        totalCount: 0
                    };
                }
                var count = (0, _EXPORTS_1.getVal)(item, valuePath) || 0;
                groupedData_1[groupKey].items.push({
                    tagId: (0, _EXPORTS_1.getVal)(item, labelPath),
                    display: (0, _EXPORTS_1.getVal)(item, labelPath),
                    _id: Math.random().toString(36).substr(2, 9),
                    count: count
                });
                groupedData_1[groupKey].totalCount += count;
            });
            // Convert grouped data to the expected format
            return Object.entries(groupedData_1).map(function (_a) {
                var key = _a[0], value = _a[1];
                return ({
                    tagCategory: key,
                    totalCountOfAllTagsWithin: value.totalCount,
                    tagSpecificCount: value.items
                });
            });
        }
        else {
            // Simple case - single category with single values
            return [{
                    tagCategory: undefined,
                    totalCountOfAllTagsWithin: data.reduce(function (sum, item) { return sum + ((0, _EXPORTS_1.getVal)(item, valuePath) || 0); }, 0),
                    tagSpecificCount: data.map(function (item) { return ({
                        tagId: (0, _EXPORTS_1.getVal)(item, labelPath),
                        display: (0, _EXPORTS_1.getVal)(item, labelPath),
                        _id: Math.random().toString(36).substr(2, 9),
                        count: (0, _EXPORTS_1.getVal)(item, valuePath) || 0
                    }); })
                }];
        }
    }
    else {
        // For breakdown case, we'll create categories based on the valuePath items
        // Each valuePath becomes a category
        return valuePath.map(function (path, pathIndex) {
            var categoryName = (tooltipLabelsMapping === null || tooltipLabelsMapping === void 0 ? void 0 : tooltipLabelsMapping[path]) || path;
            var totalCount = data.reduce(function (sum, item) { return sum + ((0, _EXPORTS_1.getVal)(item, path) || 0); }, 0);
            return {
                tagCategory: categoryName,
                totalCountOfAllTagsWithin: totalCount,
                tagSpecificCount: data
                    .map(function (item) { return ({
                    tagId: (0, _EXPORTS_1.getVal)(item, labelPath),
                    display: (0, _EXPORTS_1.getVal)(item, labelPath),
                    _id: "".concat(pathIndex, "-").concat((0, _EXPORTS_1.getVal)(item, labelPath)),
                    count: (0, _EXPORTS_1.getVal)(item, path) || 0
                }); })
                    .filter(function (tag) { return tag.count > 0; }) // Only include items with values
            };
        }).filter(function (category) { return category.tagSpecificCount.length > 0; }); // Only include categories with items
    }
};
exports.usePrepareData = usePrepareData;
